import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PackageTrackingForm from "../../utilcomponents/PackageTrackingForm";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import InboxIcon from "@mui/icons-material/MoveToInbox";
// import MailIcon from "@mui/icons-material/Mail";
import NestedList from "./NestedList";
import { Typography } from "@mui/material";
import shipatlas from "../../assets/shipatlas.jpg";
import Faq from "./Faq";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ShipTrackTab(props) {
  const { toggleDrawer } = props;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Shipping" {...a11yProps(0)} />
          <Tab label="Tracking" {...a11yProps(1)} />
          {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <NestedList toggleDrawer={toggleDrawer} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Box>
          <Box
            sx={{
              backgroundImage: `url(${shipatlas})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <PackageTrackingForm />
          </Box>
          <Box sx={{ my: "2rem" }}>
            <Typography
              sx={{
                fontWeight: "bold",
                letterSpacing: "0.1rem",
                fontSize: "1.3rem",
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Faq />
          </Box>
        </Box>
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={2}>
				Item Three
			</CustomTabPanel> */}
    </Box>
  );
}
